import React from 'react';
import { object, bool, func } from 'prop-types';
import './ProductPickerIcon.css';

function ProductPickerIcon({
  product, active, onClickIcon,
}) {
  const { recommended, type: productType, title } = product;
  const classRecommended = recommended && 'mod-recommend';
  const themes = {
    PACKAGE_DIAMOND: 'product-mini-image--diamond',
    PACKAGE_SILVER: 'product-mini-image--silver',
    PACKAGE_GOLD: 'product-mini-image--gold',
    PAID_AD: 'product-mini-image--basic',
    PAID_RENEWAL: 'product-mini-image--basic',
    FREE_RENEWAL: 'product-mini-image--basic',
    FREE_RENEWAL_PRO: 'product-mini-image--visibility-renew',
    FEE_RENEWAL_PRO: 'product-mini-image--visibility-renew',
    PACKAGE_BRONZE: 'product-mini-image--bronze',
  };
  const classImage = themes[productType];
  const classActive = active && 'active';
  return (
    <div className="product-picker-icon-container">
      <div className={`product-picker-icon ${productType} ${classActive} ${classRecommended}`} onClick={() => onClickIcon(product)}>
        <div className="product-picker-icon-image">
          <div className={`product-mini-image ${classImage}`} />
        </div>
        <div>{title}</div>
      </div>
    </div>
  );
}

ProductPickerIcon.propTypes = {
  product: object.isRequired,
  active: bool.isRequired,
  onClickIcon: func.isRequired,
};


export default ProductPickerIcon;
